import LoginPage from '@/components/Login/LoginPage.vue';
import LoginStepUserName from '@/components/Login/LoginStepUserName.vue';
import LoginStepPassword from '@/components/Login/LoginStepPassword.vue';
import LoginStepConfirm from '@/components/Login/LoginStepConfirm.vue';
import LoginStepConfirmSecure from '@/components/Login/LoginStepConfirmSecure.vue';
import LoginStepSelectSecureMethod from '@/components/Login/LoginStepSelectSecureMethod.vue';
import LoginStepShareInfo from '@/components/Login/LoginStepShareInfo.vue';
import LoginStepSelectLoginMethod from '@/components/Login/LoginStepSelectLoginMethod.vue';
import LoginStepPasswordByOTP from '@/components/Login/LoginStepPasswordByOTP.vue';
import LoginStepSelectSecureMethodForLoginOTP from '@/components/Login/LoginStepSelectSecureMethodForLoginOTP.vue';
import LoginStepRedirect from '@/components/Login/LoginStepRedirect.vue';
import LoginStepVerify from '@/components/Login/LoginStepVerify.vue';

export default [
    {
        path: "/",
        component: LoginPage,
        meta: { layout: "default", title: 'Đăng nhập' },
        name: "home"
    },
    {
        path: '/login',
        component: LoginPage,
        meta: { layout: 'default', title: 'Đăng nhập'},
        name: 'login',
        children: [
            {
                path: '',
                component: LoginStepUserName,
                name: 'logindefault',
            },
            {
                path: 'username',
                component: LoginStepUserName,
                name: 'username',
            },
            {
                path: 'password',
                component: LoginStepPassword,
                name: 'password',
            },
            {
                path: 'loginbyotp',
                component: LoginStepPasswordByOTP,
                name: 'loginbyotp',
            },
            {
                path: 'confirmlogin',
                component: LoginStepConfirm,
                name: 'confirmlogin',
            },
            {
                path: 'confirmsecure',
                component: LoginStepConfirmSecure,
                name: 'confirmsecure',
            },
            {
                path: 'selectsecure',
                component: LoginStepSelectSecureMethod,
                name: 'selectsecure',
            },
            {
                path: 'selectsecureforloginotp',
                component: LoginStepSelectSecureMethodForLoginOTP,
                name: 'selectsecureforloginotp',
            },
            {
                path: 'selectloginmethod',
                component: LoginStepSelectLoginMethod,
                name: 'selectloginmethod',
            },
            {
                path: 'shareinfo',
                component: LoginStepShareInfo,
                name: 'shareinfo',
                meta: { title: 'Chia sẻ tài khoản', requiresAuth: true }
            },
            {
                path: 'redirect',
                component: LoginStepRedirect,
                name: 'redirect',
                meta: { title: 'Chuyển hướng'}
            },
            {
                path: 'verify',
                component: LoginStepVerify,
                name: 'verify',
                meta: { title: 'Xác thực'}
            }
        ],
    },
];
